import { useQuery } from "@tanstack/react-query";
import type { AxiosResponse } from "axios";

import { GetAllPCs } from "~/API/Lookups";
import type { GenericDataResponsePortfolioCompanyLookup } from "~/Core/Models";
import type { QueryResult } from "~/Store/globals";

const Lookups = (_set, _get) => ({
  GetAllPCs(): QueryResult<AxiosResponse<GenericDataResponsePortfolioCompanyLookup>> {
    return useQuery({
      queryFn: GetAllPCs,
      queryKey: ["GetAllPCs"],
      staleTime: 0,
    });
  },
});

export default Lookups;
